<template>
  <div>
    <v-card class="border-r-0 elevation-0">
      <v-card-text>
        <v-layout row wrap >
          <v-btn flat fab small color="grey darken-4" @click="$router.push({ path: '/inventory' })">
            <v-icon>home</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn flat color="teal" dark @click="$router.push({ path: '/inventory/product/list' })"
            >Product</v-btn
          >
          <v-btn flat color="teal" dark @click="$router.push({ path: '/inventory/purchase/create' })"
            >New Purchase</v-btn
          >
          <v-btn flat color="teal" dark @click="$router.push({ path: '/inventory/purchase/list' })">
            Pruchase List</v-btn
          >
        </v-layout>
      </v-card-text>
    </v-card>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'inventory',
};
</script>
